var map = {
	"./arnaud-houa.jpeg": 91,
	"./chef-station.png": 6654,
	"./dido.jpeg": 9852,
	"./freddy-beugre.png": 1586,
	"./image001.png": 9821,
	"./pic-gallery-1.jpg": 6150,
	"./serge.jpg": 5403,
	"./testi-minister.png": 7970,
	"./testi-villager.png": 2933,
	"./testi-worker.png": 4957,
	"./villageois.jpg": 6482,
	"./yo-kassoum.jpg": 8737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;